"use client";
import Image from "next/image";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import english from "../assets/images/english.svg";
import persian from "../assets/images/persian.svg";
import i18n from "../i18n";
import Link from "next/link";

export default function Header() {
  const { t, i18n } = useTranslation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleLang = () => {
    const newLang = i18n.language === "fa" ? "en" : "fa";
    i18n.changeLanguage(newLang).then(() => {
      document.documentElement.lang = newLang;
      document.documentElement.dir = newLang === "fa" ? "rtl" : "ltr";
    });
  };

  useEffect(() => {
    document.documentElement.lang = i18n.language;
    document.documentElement.dir = i18n.language === "fa" ? "rtl" : "ltr";
  }, [i18n.language]);

  return (
    <header className="flex justify-center items-center w-full py-10 px-20 text-[#003477]">
      <div className="w-full rounded-full px-4 md:px-6 py-3 md:py-2 mx-auto flex justify-between items-center bg-white shadow-md relative">
        <div className="flex items-center gap-2 md:hidden">
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="p-2 rounded-md text-gray-700 focus:outline-none"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isMenuOpen ? (
                <path d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
          <button
            onClick={toggleLang}
            className="px-3 py-1 bg-white text-green-700 rounded text-sm font-medium hover:bg-green-100 transition mr-2"
          >
            {i18n.language === "fa" ? (
              <span className="flex justify-between gap-2">
                EN
                <Image src={english.src} alt="image" width={30} height={14} />
              </span>
            ) : (
              <span className="flex justify-between gap-2">
                فا
                <Image src={persian.src} alt="image" width={30} height={14} />
              </span>
            )}
          </button>
        </div>

        <div className="hidden md:flex items-center gap-2">
          <div className="text-xl font-bold bg-[#43CA71] w-8 h-8 rounded-full"></div>
          <div className="text-xl font-bold bg-[#43CA71] w-8 h-8 rounded-full"></div>
        </div>

        <nav className="hidden md:block">
          <ul className="flex gap-4 lg:gap-6">
            <li>
              <Link href="/">{t("home")}</Link>
            </li>
            <li>
              <Link href="/products">{t("products")}</Link>
            </li>
            <li>
              <Link href="/contact-us">{t("services")}</Link>
            </li>
            <li>
              <Link href="/contact-us">{t("support")}</Link>
            </li>
            <li>
              <Link href="/about-us">{t("about")}</Link>
            </li>
            <li>
              <Link href="/contact-us">{t("blog")}</Link>
            </li>
            <li>
              <Link href="/contact-us">{t("contact")}</Link>
            </li>
          </ul>
        </nav>

        <div className="hidden md:flex items-center">
          <button
            onClick={toggleLang}
            className="px-3 py-1 bg-white text-green-700 rounded text-sm font-medium hover:bg-green-100 transition mr-2"
          >
            {i18n.language === "fa" ? (
              <span className="flex justify-between gap-2">
                EN
                <Image src={english.src} alt="image" width={30} height={14} />
              </span>
            ) : (
              <span className="flex justify-between gap-2">
                فا
                <Image src={persian.src} alt="image" width={30} height={14} />
              </span>
            )}
          </button>
          <div className="text-xl font-bold bg-[#43CA71] w-8 h-8 rounded-full"></div>
        </div>

        {isMenuOpen && (
          <div className="absolute top-full left-0 right-0 bg-white shadow-lg rounded-2xl mt-2 p-4 md:hidden z-50">
            <nav dir="rtl">
              <ul className="flex flex-col gap-3">
                <li>
                 <Link
                    className="block py-2 px-4 hover:bg-green-50 rounded-lg transition"
                    onClick={() => setIsMenuOpen(false)}
                    href="/"
                  >
                    {t("home")}
                  </Link>
                </li>
                <li>
                 <Link
                    className="block py-2 px-4 hover:bg-green-50 rounded-lg transition"
                    onClick={() => setIsMenuOpen(false)}
                    href="/products"
                  >
                    {t("products")}
                  </Link>
                </li>
                <li>
                 <Link
                    className="block py-2 px-4 hover:bg-green-50 rounded-lg transition"
                    onClick={() => setIsMenuOpen(false)}
                    href="/contact-us"
                  >
                    {t("services")}
                  </Link>
                </li>
                <li>
                 <Link
                    className="block py-2 px-4 hover:bg-green-50 rounded-lg transition"
                    onClick={() => setIsMenuOpen(false)}
                    href="/contact-us"
                  >
                    {t("support")}
                  </Link>
                </li>
                <li>
                 <Link
                    className="block py-2 px-4 hover:bg-green-50 rounded-lg transition"
                    onClick={() => setIsMenuOpen(false)}
                    href="/about-us"
                  >
                    {t("about")}
                  </Link>
                </li>
                <li>
                 <Link
                    className="block py-2 px-4 hover:bg-green-50 rounded-lg transition"
                    onClick={() => setIsMenuOpen(false)}
                    href="/contact-us"
                  >
                    {t("blog")}
                  </Link>
                </li>
                <li>
                 <Link
                    className="block py-2 px-4 hover:bg-green-50 rounded-lg transition"
                    onClick={() => setIsMenuOpen(false)}
                    href="/contact-us"
                  >
                    {t("contact")}
                  </Link>
                </li>
              </ul>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
